module.exports = {
	"articleTitle1": "Best Ice Cream: Blank Slate Creamery ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Blank Slate Creamery",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/arts/boaa-blank-slate-creamery",
	"articleSnippet1": "Apr 2, 2017 ... I scream, you scream, we all scream when Blank Slate Creamery closes for the \nseason. Over the past few years in Ann Arbor, Blank Slate has ...",
	"articleSnippet2": "Apr 3, 2016 ... Blank Slate has flourished over the past two years in cultivating Ann Arbor's five \nsenses. Touch the smooth blackboard tabletops, get chalk on ...",
	"foodRecommendations": [
		{
			"text": "The root beer floats here are sooo good.",
			"person": "Erik Forkin"
		}
	],
	"articleTitle2": "Best Dessert: Blank Slate Creamery ",
	"address": "300 W Liberty St, Ann Arbor, MI 48103",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170405/han.BOAA_.BlankSlate.4.5.17.0012.jpg?itok=zxL2FimU",
			"author": "Joshua Han",
			"caption": ""
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/leg/imagecache/fullnode/ksp.ART_.blankslatecreamery.4.10.15.031.jpg",
			"author": "San Pham",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.279645,
		"lng": -83.751305
	},
	"totalMisc": 2,
	"categories": {
		"dessert": 1,
		"fooddrink": 1,
		"datespot": 1,
		"location": 1,
		"bestofaa": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/blankslate.json
// module id = 830
// module chunks = 0